module.exports = __webpack_public_path__ + "static/img/8.f7e0e53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/8.png
// module id = pnbU
// module chunks = 0